import { API_ENDPOINTS } from "../../enums/apiUrls";
import { getBearerToken } from "./bearerToken";

export interface RefetchPAOrderPayload {
  service_type?: string;
  location?: string;
  order_id?: string;
  practitioner_name?: string;
  regimen_name?: string;
  date_of_service?: string;
  org_id?: string;
  patient_id?: string;
}

export interface RefetchPAOrderResponse {
  data: any;
}

export const refetchPAOrder = async (
  payload: RefetchPAOrderPayload,
): Promise<RefetchPAOrderResponse> => {
  try {
    const token = await getBearerToken();
    if (!token) {
      throw new Error("No token found");
    }

    const response = await fetch(API_ENDPOINTS.REFRESH_MEDICAL_PA_ORDERS, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(
        `Request failed with status ${response.status}: ${errorData.message || response.statusText}`,
      );
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error refetching PA order:", error);
    throw error;
  }
};
